import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import proxy from './Proxy'

class Service extends ServiceBase {
  addToCart(params) {
    return this.getData(() => proxy.addToCart(params))
  }
  getLastPurchaseDate(params) {
    return this.getData(() => proxy.getLastPurchaseDate(params))
  }
}

export default new Service()
